import React from 'react';
import cx from 'classnames';
import {Tab} from '@headlessui/react';

export interface Item<T = string> {
    value: T;
    icon?: React.ReactNode;
}

interface Props<T extends Item> {
    items: T[];
    disabledItems?: T[];
    value: T['value'] | undefined;
    onClick: (item: T['value']) => void;
    itemClasses?: string;
    classNames?: string;
    vertical?: boolean;
}

function TabbedButtonToggle<T extends Item>({
    onClick,
    items,
    disabledItems,
    value,
    itemClasses = '',
    classNames = '',
    vertical = false,
}: Props<T>) {
    return (
        <Tab.Group
            vertical={vertical}
            onChange={(index) => onClick(items[index].value)}
            selectedIndex={items.findIndex((item) => item.value === value)}
        >
            <Tab.List className={cx(classNames, 'flex rounded-lg bg-neutral-950 p-1', vertical && 'flex-col')}>
                {items.map((item) => (
                    <Tab
                        key={item.value}
                        disabled={disabledItems?.some((d) => d.value === item.value)}
                        className={cx(
                            itemClasses,
                            'flex flex-auto items-center justify-center rounded-md px-2 py-2 text-xs font-semibold capitalize transition-colors focus:outline-none',
                            item.value === value ? ' bg-blue-600 text-white' : ' text-neutral-300',
                            disabledItems?.some((d) => d.value === item.value) && 'cursor-not-allowed text-neutral-600'
                        )}
                    >
                        <span className="inline-flex items-center">{item.icon || item.value}</span>
                    </Tab>
                ))}
            </Tab.List>
        </Tab.Group>
    );
}

export default TabbedButtonToggle;
